export const AI_CHAT_STEP_LIMIT_FINISH_REASON = 'step-limit';

/** Keep in sync with `AI_CHAT_CONTINUATION_PROMPT` in server/services/ai/chatRun.ts (step-budget detection). */
export const AI_CHAT_CONTINUATION_PROMPT =
  'Bitte fahre mit der noch nicht abgeschlossenen Aufgabe fort. Nutze die bisherigen Tool-Ergebnisse und wiederhole keine bereits erfolgreich ausgeführten Aktionen. Fasse das Ergebnis anschließend zusammen.';

export type PersistedRunMessage = {
  role: string;
  request_id?: string | null;
  finish_reason?: string | null;
  usage?: unknown;
};

export function persistedStepCounts(usage: unknown): {
  stepCount?: number;
  maxSteps?: number;
} {
  if (!usage || typeof usage !== 'object' || Array.isArray(usage)) return {};
  const row = usage as Record<string, unknown>;
  const stepCount = Number(row.stepCount);
  const maxSteps = Number(row.maxSteps);
  return {
    ...(Number.isFinite(stepCount) && stepCount >= 0 ? { stepCount } : {}),
    ...(Number.isFinite(maxSteps) && maxSteps > 0 ? { maxSteps } : {}),
  };
}

export function latestPendingRequestId(
  messages: PersistedRunMessage[],
): string | null {
  const assistantRequests = new Set(
    messages
      .filter((message) => message.role === 'assistant' && message.request_id)
      .map((message) => String(message.request_id)),
  );
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (
      message.role === 'user'
      && message.request_id
      && !assistantRequests.has(String(message.request_id))
    ) {
      return String(message.request_id);
    }
  }
  return null;
}

export function isStepLimitMessage(message: PersistedRunMessage): boolean {
  return (
    message.role === 'assistant'
    && message.finish_reason === AI_CHAT_STEP_LIMIT_FINISH_REASON
  );
}
